import { render } from "./LatestTransactions.vue?vue&type=template&id=4235d6b5&scoped=true&ts=true"
import script from "./LatestTransactions.vue?vue&type=script&lang=ts"
export * from "./LatestTransactions.vue?vue&type=script&lang=ts"

import "./LatestTransactions.vue?vue&type=style&index=0&id=4235d6b5&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4235d6b5"]])

export default __exports__